import styled from "styled-components";
import { isMobile } from "react-device-detect";

export const CenterContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 100vh;
  width: 100%;
`;

export const Label = styled.label`
  font-size: 0.8rem;
  margin-bottom: 5px;
  text-align: left;
`;

export const FormContainer = styled.div`
  border-radius: 5px;
  background-color: #fff;
  width: ${isMobile ? '100%' : '50%'};
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  margin-bottom: 10px;
`;

export const FieldContainer = styled.div`
  flex: 1;
  min-width: 120px;
  
  &:first-of-type {
    margin-left: 0;
  }
  
  @media (max-width: 768px) {
    flex-basis: 100%;
  }
`;

export const LeftContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const ImageContainer = styled.div`
  flex-shrink: 0;
`;

export const Heading = styled.h3`
  margin: 0;
  margin-top: 10px;
  padding-bottom: 5px;
`;

export const Paragraph = styled.p`
  padding-top: 10px;
  margin: 0 0 20px 0;
  font-size:15px;
`;